import { INIT } from './view'
import * as CardStatusRoles from 'const/CardStatusRoles'

export const NAMESPACE = 'KanBo/Board/cardStatuses/'
export const ADD = NAMESPACE + 'ADD'
export const ADD_ARRAY = NAMESPACE + 'ADD_ARRAY'
export const REMOVE = NAMESPACE + 'REMOVE'
export const SET_NAME = NAMESPACE + 'SET_NAME'
export const SET_DESCRIPTION = NAMESPACE + 'SET_DESCRIPTION'
export const SET_ROLE = NAMESPACE + 'SET_ROLE'
export const SET_IS_DEFAULT = NAMESPACE + 'SET_IS_DEFAULT'
export const SET_COLOR = NAMESPACE + 'SET_COLOR'
export const SET_POSITION = NAMESPACE + 'SET_POSITION'
export const SET_POSITIONS = NAMESPACE + 'SET_POSITIONS'

const cardStatusDefaults = {
  role: CardStatusRoles.NOT_STARTED,
  isDefault: false,
  color: 1
}

const defaultBoardState = {
  ids: [],
}

const initialState = {
  byId: {}
}

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case INIT:
      return {
        ...state,
        [action.payload.boardId]: {
          ...defaultBoardState,
        },
      }
    case ADD:
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.payload.cardStatus.id]: {
            ...cardStatusDefaults,
            ...state.byId[action.payload.cardStatus.id],
            ...action.payload.cardStatus
          }
        },
        [action.payload.boardId]: {
          ...defaultBoardState,
          ...state[action.payload.boardId],
          ids: Array.from(new Set([
            ...((state[action.payload.boardId] && state[action.payload.boardId].ids) || []),
            action.payload.cardStatus.id,
          ])),
        },
      }
    case ADD_ARRAY: {
      const newState = {
        ...state,
        byId: {
          ...state.byId,
        },
        [action.payload.boardId]: {
          ...defaultBoardState,
          ...state[action.payload.boardId],
          ids: Array.from(new Set([
            ...((state[action.payload.boardId] && state[action.payload.boardId].ids) || []),
            ...action.payload.array.map(item => item.id),
          ])),
        },
      }

      action.payload.array.forEach(item => {
        newState.byId[item.id] = {
          ...cardStatusDefaults,
          ...newState.byId[item.id],
          ...item,
        }
      })

      return newState
    }
    case REMOVE: {
      if (!state.byId[action.payload.cardStatusId]) return state

      const newState = {
        ...state,
        byId: {
          ...state.byId,
        },
      }

      delete newState.byId[action.payload.cardStatusId]

      if (
        newState[action.payload.boardId] &&
        newState[action.payload.boardId].ids &&
        newState[action.payload.boardId].ids.includes(action.payload.cardStatusId)
      ) {
        newState[action.payload.boardId] = {
          ...newState[action.payload.boardId],
          ids: newState[action.payload.boardId].ids.filter(id => id !== action.payload.cardStatusId),
        }
      }

      return newState
    }
    case SET_NAME:
      return state.byId[action.payload.cardStatusId] ? {
        ...state,
        byId: {
          ...state.byId,
          [action.payload.cardStatusId]: {
            ...state.byId[action.payload.cardStatusId],
            name: action.payload.name,
          }
        }
      } : state
    case SET_DESCRIPTION:
      return state.byId[action.payload.cardStatusId] ? {
        ...state,
        byId: {
          ...state.byId,
          [action.payload.cardStatusId]: {
            ...state.byId[action.payload.cardStatusId],
            description: action.payload.description,
          }
        }
      } : state
    case SET_ROLE:
      return state.byId[action.payload.cardStatusId] ? {
        ...state,
        byId: {
          ...state.byId,
          [action.payload.cardStatusId]: {
            ...state.byId[action.payload.cardStatusId],
            role: action.payload.role,
          }
        }
      } : state
    case SET_IS_DEFAULT:
      return state.byId[action.payload.cardStatusId] ? {
        ...state,
        byId: {
          ...state.byId,
          [action.payload.cardStatusId]: {
            ...state.byId[action.payload.cardStatusId],
            isDefault: action.payload.isDefault,
          }
        }
      } : state
    case SET_COLOR:
      return state.byId[action.payload.cardStatusId] ? {
        ...state,
        byId: {
          ...state.byId,
          [action.payload.cardStatusId]: {
            ...state.byId[action.payload.cardStatusId],
            color: action.payload.color,
          }
        }
      } : state
    case SET_POSITION:
      return state.byId[action.payload.cardStatusId] ? {
        ...state,
        byId: {
          ...state.byId,
          [action.payload.cardStatusId]: {
            ...state.byId[action.payload.cardStatusId],
            position: action.payload.position,
          }
        }
      } : state
    case SET_POSITIONS: {
      const newState = {
        ...state,
        byId: {
          ...state.byId,
        }
      }

      action.payload.positions.forEach(pos => {
        if (newState.byId[pos.id]) {
          newState.byId[pos.id] = {
            ...newState.byId[pos.id],
            position: pos.position,
          }
        }
      })

      return newState
    }
    default: return state
  }
}

export function add ({ boardId, cardStatus }) {
  return {
    type: ADD,
    payload: {
      boardId,
      cardStatus,
    }
  }
}

export function addArray ({ boardId, array }) {
  return {
    type: ADD_ARRAY,
    payload: {
      boardId,
      array,
    }
  }
}

export function remove ({ boardId, cardStatusId }) {
  return {
    type: REMOVE,
    payload: {
      boardId,
      cardStatusId,
    }
  }
}

export function setName ({ boardId, cardStatusId, name }) {
  return {
    type: SET_NAME,
    payload: {
      boardId,
      cardStatusId,
      name,
    }
  }
}

export function setDescription ({ boardId, cardStatusId, description }) {
  return {
    type: SET_DESCRIPTION,
    payload: {
      boardId,
      cardStatusId,
      description,
    }
  }
}

export function setRole ({ boardId, cardStatusId, role }) {
  return {
    type: SET_ROLE,
    payload: {
      boardId,
      cardStatusId,
      role,
    }
  }
}

export function setIsDefault ({ boardId, cardStatusId, isDefault }) {
  return {
    type: SET_IS_DEFAULT,
    payload: {
      boardId,
      cardStatusId,
      isDefault,
    }
  }
}

export function setColor ({ boardId, cardStatusId, color }) {
  return {
    type: SET_COLOR,
    payload: {
      boardId,
      cardStatusId,
      color,
    }
  }
}

export function setPosition ({ boardId, cardStatusId, position }) {
  return {
    type: SET_POSITION,
    payload: {
      boardId,
      cardStatusId,
      position,
    }
  }
}

export function setPositions ({ boardId, positions }) {
  return {
    type: SET_POSITIONS,
    payload: {
      boardId,
      positions,
    }
  }
}
